<template>
    <div style="height: 100vh;width: 100%;background-color: #E8E8E8;">
		<div  class="v">
			<img v-if="info.status==='1'" src="../assets/image/right-01.png" class="m"></img>
			<img v-else src="../assets/image/ziyuan.png" class="m"></img>
			<span class="t">{{info.message}}</span> 
		</div>
	</div>
</template>


<script>
export default {
		data() {
			return {
				info:null,
				message:'进场成功'
			}
		},
        created(){
            this.info = JSON.parse(this.$route.params.info);
        },
		mounted() {
		},
		methods: {
			
		}
	}
</script>


<style scoped>
.v{
		height: 250px;
		background-color: white;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.m{
		width: 80px;
		height: 80px;
		margin-bottom: 30px;
	}
	.t{
		font-size: 1.5rem;
        
		font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif
	}
</style>